import type { AnimationVariant } from '@game-platform/pack-animation';
import { MECHANICS } from './mechanics';

interface Props {
  value: AnimationVariant;
  onChange: (variant: AnimationVariant) => void;
}

/** One card per opening mechanic. Radio semantics like DevicePreviewToggle. */
export function MechanicPicker({ value, onChange }: Props) {
  return (
    <div role="radiogroup" aria-label="Opening mechanic" className="flex flex-col gap-2">
      {MECHANICS.map((mechanic) => {
        const active = mechanic.variant === value;
        return (
          <button
            key={mechanic.variant}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(mechanic.variant)}
            className={
              'rounded-md border px-3 py-2 text-left transition-colors ' +
              (active
                ? 'border-[var(--co-brand)] bg-[var(--co-bg)]'
                : 'border-[var(--co-border)] hover:bg-[var(--co-bg)]')
            }
          >
            <div className="text-[13px] font-semibold text-[var(--co-text)]">{mechanic.title}</div>
            <div className="mt-0.5 text-[12px] text-[var(--co-muted)]">{mechanic.description}</div>
          </button>
        );
      })}
    </div>
  );
}
